import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { getNewsBySlug } from '../data/news';
import '../styles/news.css';

const NewsPage: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const news = slug ? getNewsBySlug(slug) : undefined;

  if (!news) {
    return (
      <div className="news-page news-page--empty">
        <img src="/images/Logo.png" alt="FTDiam" className="news-page__logo" />
        <h1 className="news-page__title">News not found</h1>
        <Link to="/" className="news-page__back">
          Back to FTDiam
        </Link>
      </div>
    );
  }

  const formattedDate = new Date(`${news.date}T00:00:00`).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });

  return (
    <article className="news-page">
      <header className="news-page__header news-page__fade news-page__fade--1">
        <Link to="/" className="news-page__brand">
          <img src="/images/Logo.png" alt="FTDiam" className="news-page__logo" />
        </Link>
      </header>

      <div className={`news-page__hero news-page__fade news-page__fade--2${news.imageFit === 'contain' ? ' news-page__hero--contain' : ''}`}>
        <img src={news.image} alt={news.imageAlt} className="news-page__hero-image" />
      </div>

      <div className="news-page__content">
        <time className="news-page__date news-page__fade news-page__fade--3" dateTime={news.date}>
          {formattedDate}
        </time>
        <h1 className="news-page__title news-page__fade news-page__fade--4">{news.title}</h1>
        {news.body.map((paragraph, index) => (
          <p
            key={paragraph}
            className={`news-page__text news-page__fade news-page__fade--text`}
            style={{ animationDelay: `${0.55 + index * 0.12}s` }}
          >
            {paragraph}
          </p>
        ))}
        <Link
          to="/"
          className="news-page__back news-page__fade"
          style={{ animationDelay: `${0.55 + news.body.length * 0.12}s` }}
        >
          Back to FTDiam
        </Link>
      </div>
    </article>
  );
};

export default NewsPage;
